<template>
  <div class="nasabah">
    <p class="title">Nasabah GOFX dan Jafets</p>
    <div class="content">
      <table class="table table-striped table-bordered">
        <thead>
          <tr>
            <th>No</th>
            <th>Nama Lengkap</th>
            <th>Username</th>
            <th>Email</th>
            <th>No Telepon</th>
            <th>Platform</th>
            <th>Status</th>
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          <td colspan="9" v-show="loadingData" style="text-align: center">
            <div class="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </td>
          <tr v-for="(data, i) in dataNsb" :key="i" v-show="loadingData == false && dataNsb.length != 0">
            <td>{{ (currentPage - 1) * perPage + (i + 1) }}</td>
            <td>{{ data.name }}</td>
            <td>{{ data.username }}</td>
            <td>{{ data.email }}</td>
            <td>{{ data.phone_number }}</td>
            <td>{{ data.platform }}</td>
            <td>
              {{ data.flag_active ? "Selesai" : "Belum Ada Akun" }}
            </td>
            <td v-show="!data.flag_active">
              <button type="button" class="buttons btn-info btn-xs" data-toggle="modal" data-target="#createRoom" @click="sendId(data._id, data.username)">
                Tambah akun
              </button>
            </td>
          </tr>
          <tr v-show="loadingData == false && dataNsb.length == 0">
            <td colspan="9">No Data Available in Table</td>
          </tr>
        </tbody>
      </table>
      <b-pagination v-model="currentPage" :total-rows="dataNsb.length" :per-page="perPage" aria-controls="new-table" v-show="dataNsb.length > 10"></b-pagination>
    </div>
    <div class="modal fade" id="createRoom" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Tambah Akun Demo
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form action="">
              <div class="form-group">
                <label for="">User Id</label>
                <input type="text" class="form-input" placeholder="input user id" v-model="$v.form.username.$model" @keydown.space.prevent readonly />
                <div v-if="$v.form.username.$error">
                  <div class="form-error" v-if="!$v.form.username.required">
                    Username tidak boleh kosong
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label for="">Password</label>
                <input type="text" class="form-input" placeholder="input password" v-model="$v.form.password.$model" @keydown.space.prevent />
                <div v-if="$v.form.password.$error">
                  <div class="form-error" v-if="!$v.form.password.required">
                    Password tidak boleh kosong
                  </div>
                  <div class="form-error" v-if="!$v.form.password.minLength">
                    Password minimal 8 karakter
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-scondary" data-dismiss="modal" aria-label="Close">
              Cancel
            </button>
            <button class="btn btn-primer" @click="sendApprove">
              <div v-if="!isLoading">Submit</div>
              <b-spinner variant="light" v-else small></b-spinner>
              <!-- <Loading v-show="isLoading" /> -->
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import Loading from "../../assets/Loading.vue";
import { required, minLength } from "vuelidate/lib/validators";
export default {
  components: {
    // Loading,
  },
  data() {
    return {
      dataNsb: [],
      number: 1,
      currentPage: 1,
      perPage: 10,
      loadingData: false,
      id: "",
      isLoading: false,
      form: {
        username: "",
        password: "",
        user_id: "",
      },
    };
  },
  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
        minLength: minLength(8),
      },
    },
  },
  mounted() {
    this.loadingData = true;
    axios.get("/v1/counter/get/user/non_trading?platform=all&limit=5&offset=0").then((res) => {
      this.loadingData = false;
      this.dataNsb = res.data.data.user;
    });
  },
  computed: {
    checkRole() {
      let role = localStorage.getItem("role");
      if (role) {
        return role;
      } else {
        return null;
      }
    },
  },
  methods: {
    sendId(id, username) {
      this.id = id;
      this.form.username = username;
    },
    sendApprove() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this.isLoading = true;
      this.form.user_id = this.id;
      axios
        .post("/v1/counter/user/non_trading", this.form)
        .then((res) => {
          if (res.status == 200) {
            this.isLoading = false;
            this.$notify({
              group: "foo",
              title: "<h5>Akun Berhasil dibuat</h5>",
              type: "success",
            });
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.lds-ring {
  display: inline-block;
  width: 30px;
  height: 30px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 30px;
  height: 30px;
  margin: 6px;
  border: 6px solid #1f354a;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #1f354a transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

table {
  color: #707070 !important;
}

.nasabah {
  font-size: 14px;
  padding: 0 20px;
}

.title {
  font-size: 22px;
  font-weight: bold;
  margin: 0 0 60px;
}

.form-input {
  height: 35px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #a5a5a5;
  padding: 0 10px;
}

.btn {
  height: 40px;
  width: 110px;
  font-size: 13px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-primer:hover {
  color: #fff;
}

.form-error {
  font-size: 12px;
  margin: 5px;
  width: 50%;
  color: #e74c3c;
}
</style>
